/* tslint:disable */
/* eslint-disable */
export enum AccountType {
    Trial = 'TRIAL',
    Premium = 'PREMIUM',
    Unlimited = 'UNLIMITED',
    System = 'SYSTEM',
    Undefined = 'UNDEFINED'
}
